import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import taskReducer from './redux/taskSlice';
import toasterReducer from './redux/toasterSlice';
import globalSlice from './redux/globalSlice';
import loginReducer from './redux/loginSlice';
import dashboardSlice from './redux/dashboardSlice';
import pendingPatientSlice from './redux/pendingPatientSlice';

const combinedReducer = combineReducers({
  tasks: taskReducer,
  alert: toasterReducer,
  toaster: toasterReducer,
  global: globalSlice,
  dashboard: dashboardSlice,
  pendingPatient: pendingPatientSlice,
  user_loggedin: loginReducer,
});

export const store = configureStore({
  reducer: combinedReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
